<template>
  <div class="main">
    <!-- 红字发票确认信息录入 -->
    <div class="header-block">
      <div class="header-banner"></div>
      <div class="header-arrow">
        <el-icon @click="emits('changePage', 'redInvoice_home')"><Back /></el-icon>
        <el-breadcrumb separator-icon="arrowRight">
          <el-breadcrumb-item>红字发票业务</el-breadcrumb-item>
          <el-breadcrumb-item>红字发票开具</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
    <div class="operate-main" v-if="page == 'kaipaio'">
      <div class="common-box">
        <div class="list-wrap">
          <div class="box-line">
            <p class="box-line-title">销售方信息</p>
            <el-row>
              <el-col :span="6">
                <p>销售方名称</p>
                <p>
                  {{ detail.seller?.name }}
                </p>
              </el-col>
              <el-col :span="6">
                <p>纳税人识别号</p>
                <p>
                  {{ detail.seller?.taxRegistrationNo }}
                </p>
              </el-col>
            </el-row>
          </div>

          <div class="box-line">
            <p class="box-line-title">购买方信息</p>
            <el-row>
              <el-col :span="6">
                <p>购买方名称</p>
                <p>
                  {{ detail.buyer?.name }}
                </p>
              </el-col>
              <el-col :span="6">
                <p>纳税人识别号</p>
                <p>
                  {{ detail.buyer?.taxRegistrationNo }}
                </p>
              </el-col>
              <el-col :span="6">
                <p>购买方地址电话</p>
                <p>
                  {{ `${detail.buyer?.address || ''}${detail.buyer?.phone || ''}` }}
                </p>
              </el-col>
              <el-col :span="6">
                <p>开户行及银行账号</p>
                <p>{{ detail.buyer?.bank }}- {{ detail.buyer?.account }}</p>
              </el-col>
            </el-row>
          </div>

          <div class="box-line">
            <p class="box-line-title">对应蓝字发票信息</p>
            <el-row>
              <el-col :span="6">
                <p>发票票种</p>
                <p>{{ ['', '普通', '专用'][detail.categoryCode] }}</p>
              </el-col>
              <el-col :span="6">
                <p>开票日期</p>
                <p>{{ detail.createTime }}</p>
              </el-col>
              <el-col :span="6">
                <p>数电票号码</p>
                <p>{{ detail.code }}</p>
              </el-col>
              <el-col :span="6">
                <p>增值税用途状态</p>
                <p v-if="detail.is_operate_my === 0">已勾选</p>
                <p v-else>未勾选</p>
              </el-col>
            </el-row>
          </div>
        </div>

        <div class="table-wrap">
          <el-table :data="detail.items" :border="true">
            <el-table-column label="项目名称" prop="name" />
            <el-table-column label="规格型号" prop="specification" align="center" />
            <el-table-column label="单位" prop="unit" align="center" />
            <el-table-column label="数量" prop="count" align="center" />
            <el-table-column :label="`单价${detail.addedTax ? '（含税）' : '（不含税）'}`" prop="price" align="center" />
            <el-table-column :label="`金额${detail.addedTax ? '（含税）' : '（不含税）'}`" prop="amount" align="center">
              <template #default="{ row }">
                <span style="color: red">{{ row.amount }}</span>
              </template>
            </el-table-column>
            <el-table-column label="税率/征收率" prop="rate" align="center">
              <template #default="{ row }">
                <span>{{ row.rate * 100 + '%' }}</span>
              </template>
            </el-table-column>
            <el-table-column label="税额" prop="taxAmount" align="center" />
            <template #append>
              <div
                style="
                  box-sizing: border-box;
                  width: 100%;
                  height: 50px;
                  padding: 0 8px;
                  line-height: 50px;
                  border-bottom: 1px solid #ddd;
                  display: flex;
                "
              >
                <p style="width: 20%">合计</p>
                <p style="width: 60%; text-align: end">￥{{ detail.totalAmount }}</p>
                <p style="width: 20%; text-align: end">￥{{ detail.totalTaxAmount }}</p>
              </div>
              <div
                style="
                  box-sizing: border-box;
                  width: 100%;
                  height: 50px;
                  padding: 0 8px;
                  line-height: 50px;
                  border-bottom: 1px solid #ddd;
                  display: flex;
                "
              >
                <p style="width: 80%; text-align: end; font-weight: 700">价税合计(大写): ⊗{{ detail.payee }}</p>
                <p style="width: 20%; text-align: end; font-weight: 700">价税合计(小写)：{{ detail.totalAddedTaxAmount }}</p>
              </div>
            </template>
          </el-table>
        </div>

        <div style="display: flex; align-items: center; justify-content: center; margin-top: 20px">
          <el-button type="primary" @click="handleKaipiao">开具发票</el-button>
        </div>
      </div>
    </div>

    <!-- 开票成功 -->
    <div class="operate-main" v-if="page == 'kaipaio_end'">
      <div class="kaipiao_end">
        <div class="result"></div>
        <div style="box-sizing: border-box; width: 1200px; margin: 0px auto; padding: 20px; background-color: #f9fafe">
          <p style="line-height: 24px; font-weight: 600; font-size: 14px">发票简要信息</p>
          <el-row>
            <el-col :span="8">
              <p>
                确认方名称:<span>{{ detail.seller?.name }}</span>
              </p>
              <p>
                价税合计(元):<span>¥{{ Number(detail.totalAddedTaxAmount || 0).toFixed(2) }}</span>
              </p>
            </el-col>
            <el-col :span="8">
              <p>
                开具时间:<span>{{ detail.createTime }}</span>
              </p>
              <p>
                备注信息:
                <span>
                  {{ detail.remark }}
                </span>
              </p>
            </el-col>
            <el-col :span="8">
              <p>
                发票号码:<span> {{ detail.number }}</span>
              </p>
            </el-col>
          </el-row>
        </div>

        <div style="display: flex; align-items: center; justify-content: center; margin-top: 20px">
          <el-button type="default" @click="emits('changePage', 'redInvoice_home')">关闭页面</el-button>
          <el-button type="primary" @click="checkFapaio">查看发票</el-button>
        </div>
      </div>
    </div>

    <!-- 查看发票 -->
    <invoce-dialog v-model="visible" :row="detail" />
  </div>
</template>

<script setup name="RedInvoice/kaipaio">
import invoceDialog from '../cmp/invoceDialog.vue';
import useInvoiceStore from '@/store/modules/invoice';

const useInvoice = useInvoiceStore();
const emits = defineEmits(['changePage']);
const page = ref('kaipaio');

const detail = ref({});

onMounted(() => {
  handleQuery();
});

async function handleQuery() {
  if (sessionStorage.getItem('hzkaipiao_id')) {
    const id = sessionStorage.getItem('hzkaipiao_id');
    const data = useInvoice.redInvoiceList;
    detail.value = Object.assign(
      {},
      [...data].find((item) => item.id == id)
    );
  }
}
const getGrandchildValue = inject('getGrandchildValue');
//点击开票
function handleKaipiao() {
  useInvoice.operateRedInvoice(detail.value.id);
  page.value = 'kaipaio_end';
  sessionStorage.removeItem('hzkaipiao_id');
  getGrandchildValue.value.getData = () => {
    let params = useInvoice.redInvoiceList.find((item) => item.id == detail.value.id);
    return {
      solution: JSON.stringify(params),
    };
  };
  getGrandchildValue.value.fillFinish = () => {
    return true;
  };
}

const visible = ref(false);
function checkFapaio() {
  visible.value = true;
}
</script>

<style lang="scss" scoped>
.main {
  box-sizing: border-box;
  width: 100%;
  height: 100vh;
  font-size: 16px;
  background-color: #f6f7fb;
  display: flex;
  flex-direction: column;
  .header-block {
    flex: none;
    width: 100%;
    .header-banner {
      width: 100%;
      height: 0.64rem;
      background: #fff url('https://static.rhkj.com/renhe_fe/other/stateTax/head_log.png') no-repeat top / 100% 100%;
    }
    .header-arrow {
      width: inherit;
      height: 0.6rem;
      padding-left: 0.2rem;
      font-size: 0.18rem;
      background-color: #fff;
      display: flex;
      align-items: center;
      column-gap: 0.1rem;
      > .bread {
        margin-inline-start: 0.1rem;
        font-weight: 600;
        color: #333;
      }
    }
  }
  .operate-main {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    padding: 20px;
    overflow-y: scroll;
    .common-box {
      box-sizing: border-box;
      width: 100%;
      padding: 30px 20px 20px;
      border-radius: 3px;
      background-color: #fff;
      box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.07);
      .list-wrap {
        .box-line {
          box-sizing: border-box;
          width: 100%;
          padding: 20px;
          border-radius: 4px;
          border: 1px solid #eee;
          &:not(:first-child) {
            margin-top: 10px;
          }
          .box-line-title {
            line-height: 24px;
            font-weight: 600;
            font-size: 14px;
          }
          :deep(.el-row) {
            .el-col > p {
              font-size: 14px;
              color: #333;
              line-height: 30px;
            }
          }
        }
      }

      .table-wrap {
        width: 100%;
        min-height: 120px;
        height: calc(86vh - 530px);
        margin-top: 20px;
        overflow-x: auto;
      }
    }
    .kaipiao_end {
      box-sizing: border-box;
      width: 100%;
      padding-bottom: 20px;
      border-radius: 3px;
      background-color: #fff;
      box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.07);
      .result {
        width: 100%;
        height: 300px;
        background: #fff url('https://static.rhkj.com/renhe_fe/other/redInvoice/kaipiao_success.png') no-repeat left top / 100%;
        cursor: pointer;
      }
      :deep(.el-row) {
        .el-col > p {
          font-size: 14px;
          color: #666;
          line-height: 30px;
          > span {
            color: #333;
            margin-left: 3px;
          }
        }
      }
    }
  }
}
</style>
